import stickybits from 'stickybits';

function init() {

  stickybits('#c-post_meta__share_container', {useFixed: true, useStickyClasses: true, stickyBitStickyOffset: 20});

}

export default init;
